/**
 * Caps how many reviews are visibly shown in Klaviyo's "All Reviews" widget
 * before the Show More button, without touching how many Klaviyo actually
 * loads. Klaviyo's own click handler still adds 5 real review items to the
 * DOM per click (untouched) - all reviews stay fully present in the page's
 * HTML for SEO, this just hides the overflow with display:none until the
 * user has clicked enough times to reveal them.
 *
 * The wrapper element itself is created dynamically by Klaviyo's own script,
 * not present at DOMContentLoaded time, so this waits for it to actually
 * appear (via MutationObserver on the whole document) instead of checking
 * once and giving up.
 */
(function () {
  var WRAPPER_ID = 'klaviyo-all-reviews-wrapper';
  var ITEM_SELECTOR = '.kl_reviews__review_item';
  var BUTTON_SELECTOR = '.kl_reviews__load_more_button .kl_reviews__button, .kl_reviews__load_more_button button';
  var INITIAL_LIMIT = 5;
  var STEP = 5;

  function applyLimit(container, limit) {
    var items = container.querySelectorAll(ITEM_SELECTOR);
    for (var i = 0; i < items.length; i++) {
      items[i].style.display = i < limit ? '' : 'none';
    }
  }

  function setupWidget(wrapper) {
    var limit = INITIAL_LIMIT;
    var container = wrapper.querySelector('.kl_reviews__list_container') || wrapper;

    applyLimit(container, limit);

    var innerObserver = new MutationObserver(function () {
      applyLimit(container, limit);
    });
    innerObserver.observe(container, { childList: true, subtree: true });

    wrapper.addEventListener(
      'click',
      function (e) {
        if (!e.target.closest(BUTTON_SELECTOR)) return;
        limit += STEP;
        [50, 300, 800].forEach(function (delay) {
          setTimeout(function () {
            applyLimit(container, limit);
          }, delay);
        });
      },
      true
    );
  }

  function waitForWrapper() {
    var existing = document.getElementById(WRAPPER_ID);
    if (existing) {
      setupWidget(existing);
      return;
    }
    var outerObserver = new MutationObserver(function () {
      var wrapper = document.getElementById(WRAPPER_ID);
      if (wrapper) {
        outerObserver.disconnect();
        setupWidget(wrapper);
      }
    });
    outerObserver.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForWrapper);
  } else {
    waitForWrapper();
  }
})();
